import { BrowserRouter, Route, Routes } from "react-router";
import { CheckoutPage } from "./pages/checkout/checkout-page";
import { Checkoutv1CancelPage } from "./pages/checkoutv1-cancel-page";
import { Checkoutv1RedirectPage } from "./pages/checkoutv1-redirect-page";
import { Checkoutv1SuccessPage } from "./pages/checkoutv1-success-page";
import { HomePage } from "./pages/home-page";
import { InvoicePage } from "./pages/invoice/invoice-page";
import { InvoicePdfPage } from "./pages/invoice-pdf-page";
import { NotFoundPage } from "./pages/not-found-page";
import { PortalPage } from "./pages/portal/portal-page";
import { PortalFixture } from "./dev/portal-fixture";

/**
 * Every page this app serves.
 *
 * `/dev/portal` is mounted only in development: the signed-in portal needs a magic-link token
 * that cannot be minted without emailing a real client, so its states are rendered from a
 * fixture instead. It never reaches a build.
 */
export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/invoice/:invoiceId" element={<InvoicePage />} />
        <Route path="/invoice/:invoiceId/pdf" element={<InvoicePdfPage />} />
        <Route path="/checkout/:paymentLinkId" element={<CheckoutPage />} />
        <Route path="/portal/:stripeCustomerId" element={<PortalPage />} />
        <Route path="/checkoutv1/success" element={<Checkoutv1SuccessPage />} />
        <Route path="/checkoutv1/cancel" element={<Checkoutv1CancelPage />} />
        <Route path="/checkoutv1/404" element={<NotFoundPage />} />
        <Route path="/checkoutv1/:id" element={<Checkoutv1RedirectPage />} />
        {import.meta.env.DEV && (
          <Route path="/dev/portal" element={<PortalFixture />} />
        )}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
